module.exports = __webpack_public_path__ + "static/media/chosenImage1.a5dcb247.jpg";